import React from 'react'

const Gdpr: React.FC = () => {
  return (
    <>
      <div className="container font-myriad md:px-4 pt-8 mt-[52px] lg:mt-[84px]" id="podminky">
        <p className="mb-4">
          Tyto zásady ochrany osobních údajů (dále jen „<strong>Zásady</strong>“) popisují způsob
          získávání, používání a dalšího nakládání s osobními údaji získanými prostřednictvím
          webového rozhraní:
        </p>
        <p className="mb-8">
          <a href="http://www.dohlavy.cz/">www.dohlavy.cz</a> a{' '}
          <a href="http://www.doucovani-dohlavy.cz/">www.doucovani-dohlavy.cz</a> (dále jen „
          <strong>webové rozhraní</strong>“).
        </p>
        <h2>SPRÁVCE OSOBNÍCH ÚDAJŮ:</h2>
        <h2>DOHLAVY PŘIJÍMAČKY s.r.o., NEKLANOVA 152/42, VYŠEHRAD, 128 00 PRAHA 2</h2>
        <h2>KONTAKTNÍ ÚDAJE SPRÁVCE OSOBNÍCH ÚDAJŮ:</h2>
        <p className="mb-8">
          DOHLAVY PŘIJÍMAČKY s.r.o., Neklanova 152/42, Vyšehrad, 128 00 Praha 2<br />
          Telefonní číslo: +420 775 919 901
          <br />
          Kontaktní e-mail:&nbsp;&nbsp;<a href="mailto:info@dohlavy.cz">info@dohlavy.cz</a>
        </p>
        <h2>1. ÚVODNÍ USTANOVENÍ</h2>
        <p>
          <strong>1.1. Čím se řídíme při nakládání s osobními údaji?</strong>
        </p>
        <p>
          Při nakládání s osobními údaji postupujeme v souladu s právním řádem České republiky a
          přímo použitelnými předpisy Evropské unie, zejména se zákonem č. 110/2019 Sb., o ochraně
          osobních údajů, ve znění pozdějších předpisů (dále jen „<strong>ZOOÚ</strong>“), zákonem
          č. 480/2004 Sb., o některých službách informační společnosti a o změně některých zákonů,
          ve znění pozdějších předpisů a Nařízením Evropského parlamentu a Rady (EU) 2016/679.
        </p>
        <p>
          <strong>1.2. Co jsou osobní údaje?</strong>
        </p>
        <p>
          Osobními údaji se rozumí veškeré informace, které identifikují nebo mohou identifikovat
          konkrétní fyzickou osobu. Osobními údaji jsou zejména (avšak nikoliv výlučně):
        </p>
        <ul>
          <li>
            <strong>identifikační údaje</strong>, jako např. jméno a příjmení, rodné číslo, datum
            narození, pohlaví, přihlašovací jméno do uživatelského účtu;
          </li>
          <li>
            <strong>kontaktní údaje</strong>, jako např. adresa bydliště (nebo doručovací adresa),
            telefonní číslo, emailová adresa;
          </li>
          <li>
            <strong>další údaje</strong>, jako např. informace získané pomocí souborů cookies, IP
            adresa (síťový identifikátor) včetně typu prohlížeče, zařízení a operačního systému,
            doby a počtu přístupů na webové rozhraní a další obdobné informace.
          </li>
        </ul>
        <p className="mb-8">&nbsp;</p>
        <h2>2. ZÍSKÁVÁNÍ A VYUŽÍVÁNÍ OSOBNÍCH ÚDAJŮ</h2>
        <p>
          <strong>2.1. Jak získáváme vaše osobní údaje?</strong>
        </p>
        <p>
          Své osobní údaje nám poskytujete zejména při vyplnění kontaktního formuláře, případně při
          kontaktování naší společnosti skrze námi zveřejněné telefonní číslo, emailovou adresu či
          Facebook stránku.
        </p>
        <p>
          Při návštěvě a užívání webového rozhraní může dále docházet k získávání a ukládání
          některých osobních údajů prostřednictvím souborů cookies. Více o souborech cookies se
          dočtete v článku 5 těchto Zásad.
        </p>
        <p>
          <strong>2.2. Na jakém základě a pro jaké účely zpracováváme vaše osobní údaje?</strong>
        </p>
        <ul>
          <li>
            Osobní údaje zadané&nbsp;<strong>při objednávání zboží či služeb</strong>můžeme bez
            vašeho výslovného souhlasu shromažďovat a zpracovávat výlučně za účelem&nbsp;
            <strong>plnění smlouvy</strong>, tedy za účelem dodání zboží nebo poskytnutí služby.
            Dále můžeme tyto údaje zpracovávat za účelem&nbsp;
            <strong>splnění našich dalších zákonem stanovených povinností</strong>&nbsp;(zejména
            evidenční povinnosti, archivace daňových dokladů apod.).
          </li>
          <li>
            Pokud nám k tomu potvrzením na webovém rozhraní nebo jiným způsobem dáte&nbsp;
            <strong>souhlas</strong>, můžeme vaše osobní údaje zadané při vyplnění kontaktního
            formuláře, objednávky nebo při založení uživatelského účtu zpracovávat za účelem
            zasílání&nbsp;<strong>obchodních sdělení</strong>a&nbsp;
            <strong>přímého marketingu</strong>, případně za dalšími účely, se kterými jste výslovně
            souhlasili.
          </li>
          <li>
            Osobní údaje získávané&nbsp;<strong>prostřednictvím souborů cookies</strong>zpracováváme
            na základě vašeho souhlasu (který můžete udělit potvrzením na webovém rozhraní poté, co
            jste byli na používání cookies upozornění a měli jste možnost seznámit se s těmito
            Zásadami). Osobní údaje získávané prostřednictvím souborů cookies jsme oprávněni
            zpracovávat i v případě, že dále užíváte webové rozhraní i poté, co jste byli na
            zpracování těchto osobních údajů upozorněni. Osobní údaje získávané prostřednictvím
            souborů cookies využíváme pro účely&nbsp;
            <strong>
              provádění uživatelské podpory, zlepšování našich služeb včetně analýzy chování
              uživatelů
            </strong>
            &nbsp;a&nbsp;<strong>marketingu</strong>.
          </li>
        </ul>
        <p>
          <strong>
            Použít vaše osobní údaje k jinému účelu, než pro který byly získány, můžeme jen na
            základě vašeho souhlasu.
          </strong>
        </p>
        <p>
          <strong>2.3. Po jak dlouhou dobu údaje využíváme?</strong>
        </p>
        <ul>
          <li>
            Osobní údaje zadané v rámci objednávání zboží či služeb nebo v rámci registrace
            využíváme pouze po dobu nezbytnou pro splnění smlouvy a splnění právních povinností.
          </li>
          <li>
            Pokud nám udělíte souhlas výslovný se zpracováním osobních údajů, budou údaje využity po
            dobu trvání účelu, pro který byl souhlas udělen, nebo po maximální dobu 5 let.
          </li>
        </ul>
        <p>
          <strong>2.4. S&nbsp;kým Vaše osobní údaje sdílíme?</strong>
        </p>
        <ul>
          <li>
            Veškeré osobní údaje získané od zákazníků využíváme výhradně pro vnitřní potřebu
            společnosti, chráníme před zneužitím a neposkytujeme třetím stranám bez předchozího
            upozornění nebo vašeho souhlasu.
          </li>
        </ul>
        <p>
          Výjimku představují naši smluvní lektoři a externí subjekty, které pro nás zajišťují
          podpůrné služby (např. vedení účetnictví apod.) a orgány státní moci. Těmto všem subjektům
          vaše osobní údaje poskytnout můžeme či musíme v minimálním rozsahu, který je nutný pro
          bezproblémové vyřízení objednávky nebo fungování společnosti samotné, včetně plnění jejich
          povinností.
        </p>
        <p>Jde zejména o tyto činnosti:</p>
        <ul>
          <li>
            za účelem poskytování našich služeb mohou být vaše osobní údaje předány externímu
            lektorovi, který vám poskytne objednané služby naším jménem,
          </li>
          <li>
            pokud je to nezbytné pro vyšetřování protiprávní činnosti nebo pro potřeby soudního
            řízení, mohou být údaje předány orgánům pro vyšetřování trestné činnosti,
          </li>
          <li>
            za účelem vedení účetnictví a s&nbsp;tím spojených podpůrných aktivit předáváme vaše
            údaje vstupující do našeho obchodního vztahu externí účetní a daňové kanceláři (Institut
            práva a obchodu s.r.o.),
          </li>
          <li>
            za dalším zpracováním jiným zpracovatelům v&nbsp;případě, kdy je takové poskytnutí nutné
            pro zachování hladkého chodu podnikání.
          </li>
        </ul>
        <p className="mb-8">
          U všech těchto poskytovatelů služeb smluvně požadujeme, aby zpracovávali vaše osobní údaje
          v souladu s podmínkami ochrany osobních údajů a platnou legislativou.
        </p>
        <h2>3. VAŠE PRÁVA V SOUVISLOSTI S OSOBNÍMI ÚDAJI</h2>
        <p>
          <strong>3.1. Právo na odvolání souhlasu se zpracováním osobních údajů</strong>
        </p>
        <p>
          Pokud zpracováváme vaše osobní údaje jen na základě vašeho souhlasu (tj. bez jiného
          zákonného důvodu), můžete tento souhlas kdykoliv odvolat.
        </p>
        <p>Odvolání souhlasu se zpracováním vašich osobních údajů je možné kdykoliv, a to:</p>
        <ul>
          <li>prostřednictvím e-mailu zaslaného na naši kontaktní e-mailovou adresu;</li>
          <li>písemně formou dopisu zaslaného na naši doručovací adresu;</li>
        </ul>
        <p>
          Odvoláním souhlasu není dotčena zákonnost zpracování údajů prováděného do doby odvolání
          souhlasu se zpracováním.
        </p>
        <p>
          <strong>3.2. Právo na přístup k osobním údajům</strong>
        </p>
        <p>
          Máte právo nás požádat o informaci, zda provádíme zpracování vašich osobních údajů. Pokud
          vaše údaje zpracováváme, máte právo na přístup k těmto osobním údajům a zejména k
          následujícím informacím:
        </p>
        <ul>
          <li>účel zpracování;</li>
          <li>kategorie zpracovávaných osobních údajů;</li>
          <li>příjemci nebo kategorie příjemců, kterým budou osobní údaje zpřístupněny;</li>
          <li>doba, po kterou budou osobní údaje uloženy.</li>
        </ul>
        <p>
          Na vaši žádost vám poskytneme kopii zpracovávaných údajů. Za další kopie vám můžeme
          účtovat administrativní poplatek nepřevyšující náklady spojené s vyhotovením a předáním
          těchto dalších kopií.
        </p>
        <p>
          <strong>3.3. Právo na opravu</strong>
        </p>
        <p>
          Pokud jsou vaše osobní údaje nepřesné nebo neúplné, máte právo požadovat bezodkladnou
          nápravu, tj. opravu nepřesných údajů a/nebo doplnění neúplných údajů.
        </p>
        <p>
          <strong>3.4. Právo vznést námitku proti zpracování</strong>
        </p>
        <p>
          Máte právo kdykoliv vznést námitku proti zpracování vašich osobních údajů, včetně
          jakéhokoliv automatizovaného zpracování osobních údajů. Po vznesení námitky přestaneme
          vaše osobní údaje pro tyto účely dále zpracovávat.
        </p>
        <p>
          <strong>3.5. Právo na výmaz</strong>
        </p>
        <p>V případě, že:</p>
        <ul>
          <li>
            osobní údaje již nejsou potřebné pro účely, pro které byly shromážděny nebo
            zpracovávány;
          </li>
          <li>jste odvolali souhlas se zpracováním;</li>
          <li>jste vznesli námitky proti zpracování osobních údajů osobních údajů;</li>
          <li>osobní údaje byly zpracovávány protiprávně,</li>
        </ul>
        <p>
          máte právo požadovat, abychom vaše osobní údaje smazali. Pokud neexistují zákonné důvody
          pro odmítnutí vymazání, jsme povinni vaší žádosti vyhovět.
        </p>
        <p>
          <strong>3.6. Právo na omezení zpracování</strong>
        </p>
        <p>V případě, že:</p>
        <ul>
          <li>popíráte přesnost svých osobních údajů;</li>
          <li>
            je zpracování protiprávní a vy namísto výmazu žádáte o omezení zpracování osobních
            údajů;
          </li>
          <li>
            již vaše osobní údaje nepotřebujeme pro účely zpracování, ale vy je požadujete pro
            určení, výkon či obhajobu právních nároků;
          </li>
          <li>vznesete námitku proti zpracování,</li>
        </ul>
        <p>
          můžete požadovat, abychom omezili zpracování vašich osobních údajů. Při omezení zpracování
          jsme pouze oprávněni vaše osobní údaje uložit; další zpracování je možné jen s vaším
          souhlasem, nebo ze zákonných důvodů.
        </p>
        <p>
          Pokud je zpracování osobních údajů omezeno z důvodu námitky proti zpracování, trvá omezení
          po dobu nutnou pro zjištění, zda jsme povinni vaší námitce vyhovět.
        </p>
        <p>
          Pokud je zpracování osobních údajů omezeno z důvodu popření přesnosti údajů, trvá omezení
          po dobu ověření přesnosti údajů.
        </p>
        <p>
          <strong>3.7. Právo na přenositelnost údajů</strong>
        </p>
        <p>
          Máte právo na získání vašich osobních údajů, které jste nám poskytli, ve strukturovaném,
          běžně používaném a strojově čitelném formátu a předat je jinému správci osobních údajů.
        </p>
        <p>
          <strong>3.8. Jak můžete svá práva uplatnit?</strong>
        </p>
        <p>
          Vaše práva v souvislosti s osobními údaji můžete uplatnit prostřednictvím našich
          kontaktních údajů. Veškeré informace a úkony vám budou poskytnuty bez zbytečného odkladu.
        </p>
        <p>
          Při ochraně vašich osobních údajů vám vyjdeme maximálně vstříc. Pokud ovšem s vyřízením
          nebudete spokojeni, máte právo obrátit se na příslušné orgány, zejména na Úřad pro ochranu
          osobních údajů (<a href="http://www.uoou.cz/">http://www.uoou.cz</a>), který vykonává
          dozor nad ochranou osobních údajů. Tímto ustanovením není dotčeno vaše oprávnění obrátit
          se se svým podnětem na Úřad pro ochranu osobních údajů přímo.
        </p>
        <p className="mb-8">
          Pokud se zejména vaše bydliště, místo výkonu zaměstnání nebo místo údajného porušení
          ochrany osobních údajů nachází mimo Českou republiku v jiném členském státě Evropské unie,
          můžete se obrátit na příslušný dozorový úřad v tomto členském státě.
        </p>
        <h2>4. SPRÁVA A ZPRACOVÁNÍ OSOBNÍCH ÚDAJŮ</h2>
        <p>
          <strong>4.1. Jak spravujeme a zpracováváme vaše osobní údaje?</strong>
        </p>
        <p>
          Jsme správcem osobních údajů ve smyslu ZOOÚ a nařízení EU o GDPR. Osobní i další získávané
          údaje jsou plně zabezpečeny proti zneužití.
        </p>
        <p>
          Osobní údaje budou zpracovávány v elektronické podobě automatizovaným způsobem nebo v
          tištěné podobě neautomatizovaným způsobem.
        </p>
        <p>
          <strong>Písemná podoba</strong>
        </p>
        <p>
          Osobní údaje zákazníků jsou obsaženy zejména na formulářích, které jsou uschovávány
          v&nbsp;uzamykatelném místě v uzamykatelných prostorách společnosti, ke kterým má přístup
          pouze vymezený okruh pověřených osob.
        </p>
        <p>
          Správce je povinen učinit vše pro to, aby byly shromažďovány pouze aktuální dokumenty a
          záznamy obsahující aktuální údaje o zákazníkovi. Z tohoto důvodu jsou dokumenty průběžně
          aktualizovány.
        </p>
        <p>
          Pokud je odvolán souhlas zákazníka se zpracováním osobních údajů konkrétního zákazníka, je
          nutno listiny obsahující osobní údaje skartovat, nejde-li o listiny, které je nutno podle
          zvláštních předpisů dále archivovat.
        </p>
        <p>
          Za skartaci zodpovídá zaměstnanec pověřený&nbsp;<em>Archivační a skartační směrnicí</em>.
        </p>
        <p>
          O přístupu pověřených osob k listinám obsahující osobní údaje bude vedena pověřeným
          zaměstnancem evidence.
        </p>
        <p>
          Po ukončení práce je pověřená osoba povinna listinu vrátit zpět, nebo osobě, která ji
          složku vydala.
        </p>
        <p>
          <strong>Elektronická podoba</strong>
        </p>
        <p>
          V informačním systému správce jsou evidovány získané osobní údaje a další informace
          důležité pro potřeby jejich dalšího zpracování.
        </p>
        <p>
          Údaje v této podobě jsou zpracovávány prostřednictvím informačního systému Dohlavy,
          účetního programu a kancelářských nástrojů společnosti Microsoft.
        </p>
        <p>
          Přístup do databází mají pověření zaměstnanci společnosti a jiné osoby, které k tomu mají
          oprávnění na základě uzavřené smlouvy.
        </p>
        <p>
          Přístup do databází je chráněn individuálním heslem. V případě, že pověřená osoba přeruší
          práci s databází a chce od počítače odejít nebo práci ukončit, je povinna se odhlásit. V
          případě ukončení pracovního poměru pověřeného zaměstnance je povinností nadřízeného
          zajistit zrušení jeho účtu a hesla. Pro vnášení údajů do informačního systému je povoleno
          používat pouze počítače společnosti. Přístup na tyto počítače musí být chráněný heslem.
        </p>
        <p className="mb-8">
          Osobní údaje v elektronické podobě na přenosných digitálních záznamových médiích musí být
          opatřeny heslem a uloženy stejným způsobem jako písemnosti dle těchto zásad.
        </p>
        <h2>5. SOUBORY COOKIES</h2>
        <p>
          <strong>5.1. Co jsou to cookies?</strong>
        </p>
        <p>
          Cookies jsou textové soubory ukládané do počítače nebo jiného elektronického zařízení
          každého návštěvníka webového rozhraní, které umožňují fungování webového rozhraní.
        </p>
        <p>
          Ne všechny cookies shromažďují osobní údaje, některé pouze umožňují správné fungování
          webového rozhraní. Používání souborů cookies můžete odmítnout volbou v příslušném
          nastavení v internetovém prohlížeči.
        </p>
        <p>
          Upozorňujeme na to, že při odmítnutí používání souborů cookies není vyloučeno, že nebudete
          moci plně využívat veškeré funkce webového rozhraní.
        </p>
        <p>
          <strong>5.2. Jaké cookies a pro jaké účely je webové rozhraní využívá?</strong>
        </p>
        <p>
          Cookies používáme ke zlepšení funkčnosti našich stránek a zjednodušení vaší příští
          návštěvy, zejména pak pro tyto činnosti:
        </p>
        <ul>
          <li>
            uložení předvoleb a nastavení, která umožňují, aby naše webové stránky fungovaly
            správně,
          </li>
          <li>
            přihlášení a ověřování – pokud se nechcete stále přihlašovat a odhlašovat, díky cookies
            nemusíte,
          </li>
          <li>
            zabezpečení – cookies používáme k odhalování podvodů a zneužití našich webových stránek,
          </li>
          <li>analýzy – pomocí cookies shromažďujeme data pro naše analytické nástroje,</li>
          <li>
            cookies využíváme pro vyhodnocení našich marketingových kampaní nebo pro oslovení
            zákazníků,
          </li>
          <li>sociální sítě – některý obsah z našich stránek můžete sdílet s vašimi přáteli</li>
        </ul>
        <p>
          Navzdory výše uvedenému na základě souborů cookies vás nejsme schopni identifikovat na
          úroveň konkrétní fyzické osoby.
        </p>
        <p>
          <strong>5.3. Google Analytics a Adwords</strong>
        </p>
        <p>
          Webové rozhraní používá službu Google Analytics a případně i další služby poskytované
          společností Google, Inc (dále jen „<strong>Google</strong>“). Tyto služby pracují s
          informacemi získanými prostřednictvím souborů cookies.
        </p>
        <p className="mb-8">
          Pokud vás zajímá, jak Google využívá data, které od nás získává, a jak zpracování upravit
          nebo zakázat, dozvíte se tyto informace kliknutím na
          <br />
          následující odkaz:&nbsp;
          <a href="https://www.google.com/intl/cs/policies/privacy/partners/">
            <strong>
              Jak Google využívá data, když používáte weby nebo aplikace našich partnerů.
            </strong>
          </a>
        </p>
        <p>Tyto Zásady jsou platné a účinné od 01.09.2018.</p>
        <p>
          <strong>&nbsp;</strong>
        </p>
      </div>
    </>
  )
}

export default Gdpr
